import React from "react";
import {
  Header,
  FooterLinks,
  Subsection,
  Subsubheader,
  DataPageContainer,
  QuoteLeft,
} from "../components";

function AdviceConclusions() {
  return (
    <DataPageContainer className="AdviceConclusion">
      <Header>Advice & Conclusions</Header>
      <Subsection title="Q: If you were to offer advice to a first-year, what would it be?">
        <QuoteLeft author="anon">
          Math coffee... BETTER THAN ENG COFFEE
        </QuoteLeft>
        <Subsubheader>Summary of Advice From the Whole Class</Subsubheader>
        <ul className="AdviceList">
          <li>
            The most common piece of advice that came from the class: It’s
            extremely important to find your school work/life balance. It may
            take time (a couple years even) but that’s a part of growth. It’s
            arguably just as important to make friends in and out of the class –
            you may not know it now, but your friends may become the most
            important component of your success in so many ways.
          </li>
          <li>
            Have fun!! University is a big part of your life, but any mistakes
            and failures that come your way are only stepping stones for growth,
            and are always possible to overcome. Don’t take anything too
            seriously. Learn how to look after your mental health if you haven’t
            before. University will challenge you like nothing before.
          </li>
          <li>
            Get involved with a team or intramural or club. Don’t be afraid to
            sign up for a lot and back off as you need to. Take advantage of
            your environment to learn new things and have new experiences –
            especially outside of class.
          </li>
          <li>
            BE YOURSELF. And University is a time to find yourself and grow.
            Don’t compare yourself to others all the time. Take risks!
          </li>
          <li>
            Give your best effort in everything you do. While you’re remembering
            to enjoy yourself, don’t forget about your assignments!! Another big
            piece of advice we have to give is do your best to stay on top of
            your schoolwork and DON’T leave everything to the end.
          </li>
          <li>
            A few people also advised to look more in-depth into the whole Tron
            program and what it offers. It comes back to learning what you want
            to do with your life and career.
          </li>
        </ul>
        <Subsubheader>Notable Advice From Our Classmates</Subsubheader>
        <QuoteLeft>
          Make friends with with people outside your class/program as well as
          in. I had just as many friends in other disciplines (maybe more) than
          in TRON and found it way less boring than always talking about/sharing
          the same experiences day in and day out. More friends from various
          fields = more diverse experiences
        </QuoteLeft>
        <QuoteLeft>
          If you are not too interested in mechanical engineering aspect,
          consider switching to SYDE or ECE pronto
        </QuoteLeft>
        <QuoteLeft>
          Build a portfolio, even of your hobbies. Be able to show [your
          talents] - that proves to yourself that you've improved
        </QuoteLeft>
        <QuoteLeft>
          Someone once said, "Life is too short to be at war with yourself." If
          you ever feel at war with yourself, do the changes you need to do! You
          will slowly work up the coop ladder to where you want to be - the
          first coop is the hardest, try to use your connections outside of
          WaterlooWorks to get that first job. And lastly, do extracurriculars!
          I wish I started karate in 1A instead of in 4A. You want to keep your
          soul nurtured during this long journey. :)
        </QuoteLeft>
        <QuoteLeft>
          First-year co-ops don't define you; over the years you'll end up where
          you want to be.
        </QuoteLeft>
        <QuoteLeft>
          Figure out what your ideal life looks like and don't let anyone tell
          you what your ideal life should look like. Some people will be
          singularly focused on career and others on social life, and others
          will try to get involved with many different things. No approach is
          right or wrong. As such, figure out what success means to you and work
          towards that, don't compare your life with others because everyone is
          working towards something different. This would have saved me from
          bouncing around in life trying to mimic what others were doing instead
          of what I wanted to do. Finally, do the right thing, and give yourself
          time to develop. My life was worse than I hoped in first year in most
          aspects, but better than I could have expected by fourth year in most
          aspects. Confidence and maturity come with time--it's impossible to
          rush the process of growth. Also workout. Just do it, there's no
          reason not to. If you stick with it, it will be one of the best
          decisions you'll ever make.
        </QuoteLeft>
        <QuoteLeft>
          Use side projects to build knowledge and see what type of work
          you’ll enjoy.
        </QuoteLeft>
        <QuoteLeft>
          You are going to get a lot of advice in first year, not all of it is
          good advice.
        </QuoteLeft>
      </Subsection>
      <Subsection title={"Conclusions"}>
        What an INCREDIBLE wealth of experiences we have both shared and had
        individually as a class at Waterloo. The diversity that we came together
        with in the beginning only grew as we developed ourselves in our
        personal and professional lives - and paradoxically, we grew closer.
        {"\n\n"}
        No algorithm could have predicted the paths we would go down (though
        with this survey in hand, maybe one of us will be able to develop
        something for the future{" "}
        <span role="img" aria-label="winking emoji">
          😉
        </span>
        ).
        {"\n\n"}
        From all of us behind the development of this profile, we thank you for
        your participation in the class survey if you did indeed partake, and
        hope that you gleaned some interesting and perhaps entertaining
        information about your fellow classmates to brighten your day in these
        chaotic times.
        {"\n\n"}
        To those perusing our profile as a third party observer, we hope that
        you learned some interesting facts about our class, and leave with an
        idea of just how special and unique each of our experiences has built us
        out to be.
        {"\n\n"}
        We hope that future Mechatronics classes are able to use what we have
        started. See how to contact us below if you have any questions regarding 
        content or privacy.
        
      </Subsection>
      <Subsection title={"Credits"}>
        Lastly, a HUGE THANK YOU to the amazing people who helped in making this profile a
        reality. Feel free to reach out and connect with us on LinkedIn!
        {"\n"}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/annie-cui/"
        >
          Annie Cui
        </a>
        : Site design.
        {"\n"}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/susangao1/"
        >
          Susan Gao
        </a>
        : Front-end implementation, some data processing, survey creation.
        {"\n"}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/nikhilkeswani/"
        >
          Nikhil Keswani
        </a>
        : Site content and data analysis, survey creation.
        {"\n"}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/keyan-rhm/"
        >
          Keyan Raahemifar
        </a>
        : Survey creation.
        {"\n"}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/andy-tan3/"
        >
          Andy Tan
        </a>
        : Data processing, front-end implementation, survey creation.
        {"\n"}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.linkedin.com/in/jcwebster/"
        >
          John Webster
        </a>
        : Site content and data analysis, survey creation.
        {"\n\n"}
        And, as noted in the foreward, this class profile is based on other
        class profiles that have been created by UWaterloo engineering classes,
        such as the{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://ndey96.github.io/syde_2019_class_profile.pdf"
        >
          SYDE 2019 class profile
        </a>{" "}
        and the{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://uw-se-2020-class-profile.github.io/profile.pdf"
        >
          SE 2020 class profile
        </a>
        . This profile is not affiliated with the MTE program or the University
        of Waterloo in any way. {"\n\n"}

        If you have any feedback/concerns for us, 
        please use these Google Forms: {"\n"}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="          https://forms.gle/cBTjXcmJqSgj3f3n9
          "
        >
          Feedback Submission Form
        </a> {"\n"}
      </Subsection>
      <FooterLinks
        back={{ text: "view future plans data", to: "future-plans" }}
        next={{ text: "view photo gallery", to: "photos" }}
      />
    </DataPageContainer>
  );
}

export default AdviceConclusions;
